import styled from 'styled-components';

export const Container = styled.div`
  width: ${props => props.size || '30px'};
  height: ${props => props.size || '30px'};
`;
